import * as React from 'react';
import { Table, Button, Header } from 'semantic-ui-react';


export interface ISubscriptionInfoProps {
	planId: string;
	subscriptionId: string;
	planName: string;
	expiry?: string;
	discounts?: string;
	// openPlanDetails(subscriptionId);
	openBillingAddress();
	openPaymentSources();
}

export const SubscriptionInfoComponent: React.SFC<ISubscriptionInfoProps> = (props) => {
	return (
		<Table celled>
			<Table.Header>
				<Table.Row>
					<Table.HeaderCell >Plan</Table.HeaderCell>
					<Table.HeaderCell >Expiry</Table.HeaderCell>
					<Table.HeaderCell >Coupons/Discount</Table.HeaderCell>
				</Table.Row>
			</Table.Header>
			<Table.Body>
				<Table.Row>
					<Table.Cell>{props.planName}</Table.Cell>
					<Table.Cell>{props.expiry}</Table.Cell>
					<Table.Cell>{props.discounts}</Table.Cell>
				</Table.Row>
			</Table.Body>
			<Table.Footer>
				<Table.Row>
					<Table.HeaderCell colSpan='3'>
						<Header as='h4'>Update Billing Information</Header>
						{/* <Button compact onClick={() => props.openPlanDetails(props.subscriptionId)}>Plan</Button> */}
						<Button size="small" onClick={() => props.openBillingAddress()} style={{ padding: 12 }}>Billing Address</Button>
						<Button size="small" onClick={() => props.openPaymentSources()} style={{ padding: 12 }}>Payment Method</Button>
					</Table.HeaderCell>
				</Table.Row>
			</Table.Footer>
		</Table>
	);
}




// WEBPACK FOOTER //
// ./src/components/presentational/views/AccountSettings/SubscriptionInfo/index.tsx